import ValidationResult from "./validation-result";

interface HttpError {
    code: string;
    message: string;
    value: string | null;
}

export const isHttpError = (error: HttpError | ValidationResult | ValidationResult[]): error is HttpError => {
  return "code" in error && "message" in error && "value" in error;
};

export const newHttpError = (code: string, message: string, value: string | null = null) => {
  return {
    code: code,
    message: message,
    value: value,
  } as HttpError;
};

export default HttpError;


// mock data

export const mockHttpError = { 
  code: "500", 
  message: "some message", 
  value: "some value" 
} as HttpError;